import React from 'react'
import './home.css'

function Homepage(){

    return (
        <>
            <div>Homepage</div>
        </>
    ) 
}

export default Homepage;